<div [ngClass]="['px-1 py-0.5 sm:px-2 sm:py-1', color === 'disabled' ? 'cursor-default' : 'cursor-pointer']"
  class="{{ badgeBackgroundColor[color] }} flex ml-auto sm:mx-auto border-1 items-center rounded-[4px] text-[10px] sm:text-xs font-medium gap-1 w-fit">
  @if (text) {
  <span id="B72F8503-6340">{{ text }}</span>
  }

  @if (flatIcon) {
  <i id="1FFAEFE7-E278" class="{{ flatIcon }} leading-3"></i>
  }
</div>